import { ProgressBar } from '@react-pdf-viewer/core';

export default function Loader(percentages) {
	return (
		<div style={{ width: '240px' }}>
			<ProgressBar progress={Math.round(percentages)} />
		</div>
	);
}
